import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { Row, Col } from 'wonderbly-components/lib/Grid';
import Panel from 'wonderbly-components/lib/Panel';
import ShippingCountry from './ShippingCountry';
import ShippingOptions from './ShippingOptions';
import ShippingAddress from './ShippingAddress';
import ShippingCost from './ShippingCost';
import { findType } from './ShippingDate/helpers';

import get from 'lodash/get';

import './Shipping.scss';

const Shipping = props => (
  <section className="shipping container-guttered">
    <h2 className="shipping-title">{props.title}</h2>
    <Panel className="shipping-panel" border="shadow">
      <Row colsToRowsOn="fablet-down">
        {props.items.map((item, i) => {
          switch (kebabCase(item.options)) {
            case 'shipping-country': {
              return (
                <Col className="shipping-col" key={`item-${i}`}>
                  <ShippingCountry
                    countryIso={props.values.countryIso}
                    onChange={props.handleChange}
                    setFieldValue={props.setFieldValue}
                    eagleCountries={get(props, 'model.eagleModel.countries', [])}
                    prismicCountries={get(props, 'countries.country.countryOption', [])}
                    states={props.regionStates[props.values.countryIso] || []}
                    header={item.header}
                  />
                </Col>
              );
            }
            case 'estimated': //TODO delete 'estimated' after Prismic implementation
            case 'standard':
            {
              return (
                <Col className="shipping-col" key={`item-${i}`}>
                  <ShippingOptions
                    header={item.header}
                    shippingDates={props.shippingDates}
                    isLoading={props.isLoading}
                    countryModel={props.model.countryModel}
                  />
                </Col>
              );
            }
            case 'options': //TODO delete 'options' after Prismic implementation
            case 'express':
            {
              if (!findType(props.shippingDates, 'tracked')) {
                return null;
              }
              return (
                <Col className="shipping-col" key={`item-${i}`}>
                  <ShippingOptions
                    header={item.header}
                    description={item.description}
                    shippingDates={props.shippingDates}
                    isLoading={props.isLoading}
                    countryModel={props.model.countryModel}
                    isTracked
                  />
                </Col>
              );
            }
            case 'address': {
              const shippingCountry = get(props, 'order.shipping.country_iso');
              const shippingStates = shippingCountry && props.regionStates[shippingCountry] || [];
              return (
                <Col className="shipping-col" key={`item-${i}`}>
                  <ShippingAddress
                    {...props}
                    header={item.header}
                    shipping={props.order.shipping}
                    prismicCountries={get(props, 'countries.country.countryOption', [])}
                    states={shippingStates}
                  />
                </Col>
              );
            }
            case 'cost': {
              return (
                <Col className="shipping-col" key={`item-${i}`}>
                  <ShippingCost
                    header={item.header}
                    shipping={props.order.shipping}
                    shipmentTotal={props.order.shipmentTotal}
                  />
                </Col>
              );
            }
          }
        })}
      </Row>
    </Panel>
  </section>
);

Shipping.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  order: PropTypes.shape({
    shipping: PropTypes.object,
    shipmentTotal: PropTypes.object,
  }),
  values: PropTypes.shape({
    countryIso: PropTypes.string.isRequired,
  }),
  model: PropTypes.shape({
    countryModel: PropTypes.shape({
      iso: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  shippingDates: PropTypes.arrayOf(PropTypes.object),
  regionStates: PropTypes.object,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default Shipping;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/Shipping.js